'use client';

// eslint-disable-next-line
export { default } from 'react-modal';
